import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, InputAdornment } from '@mui/material';
import styled from '@emotion/styled';
import { FormField, Row, HalfWidthField } from './sharedStyles';

const FirstFormField = styled(FormField)(({ theme }) => ({
    marginTop: theme.spacing(1),
}));

const SkillDialog = ({ open, onClose, onSave, skill, mode = 'create' }) => {
    const [formData, setFormData] = useState({
        name: '',
        hourlyRate: '',
        retainerRate: '',
    });

    useEffect(() => {
        if (skill && mode === 'edit') {
            setFormData({
                name: skill.name || '',
                hourlyRate: skill.hourlyRate || '',
                retainerRate: skill.retainerRate || '',
            });
        } else {
            setFormData({
                name: '',
                hourlyRate: '',
                retainerRate: '',
            });
        }
    }, [skill, mode, open]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSave = () => {
        const dataToSave = {
            name: formData.name,
            hourlyRate: parseFloat(formData.hourlyRate),
            retainerRate: parseFloat(formData.retainerRate),
        };
        onSave(dataToSave);
        handleClose();
    };

    const handleClose = () => {
        setFormData({
            name: '',
            hourlyRate: '',
            retainerRate: '',
        });
        onClose();
    };

    const isValid = () => {
        return formData.name.trim() !== '' &&
               formData.hourlyRate !== '' &&
               formData.retainerRate !== '' &&
               !isNaN(parseFloat(formData.hourlyRate)) &&
               !isNaN(parseFloat(formData.retainerRate)) &&
               parseFloat(formData.hourlyRate) >= 0 &&
               parseFloat(formData.retainerRate) >= 0;
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{mode === 'create' ? 'Create' : 'Edit'} Skill</DialogTitle>
            <DialogContent>
                <FirstFormField>
                    <TextField
                        fullWidth
                        label="Skill Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        helperText="e.g., React Development, Python Programming"
                    />
                </FirstFormField>
                <Row>
                    <HalfWidthField>
                        <TextField
                            fullWidth
                            type="number"
                            label="Hourly Rate"
                            name="hourlyRate"
                            value={formData.hourlyRate}
                            onChange={handleChange}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            }}
                            required
                            inputProps={{ min: 0, step: 0.01 }}
                        />
                    </HalfWidthField>
                    <HalfWidthField>
                        <TextField
                            fullWidth
                            type="number"
                            label="Retainer Rate"
                            name="retainerRate"
                            value={formData.retainerRate}
                            onChange={handleChange}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            }}
                            required
                            inputProps={{ min: 0, step: 0.01 }}
                        />
                    </HalfWidthField>
                </Row>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button variant="contained" color="primary" onClick={handleSave} disabled={!isValid()}>
                    {mode === 'create' ? 'Create' : 'Update'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SkillDialog;
